import { createFileRoute } from '@tanstack/react-router';

import { Chat } from '@mint-sdk/api-ai-assistant';

export const Route = createFileRoute('/_secured/ai-hub/')({
  async beforeLoad({ context }) {
    const hasAccess = await context.isFlagEnabled(
      '@myn/secured',
      'aiHubAccess',
    );

    const hasPermissionFlag = await context.isFlagEnabled(
      '@mint/arm',
      'checkAiPermission',
    );

    const hasViewPermission = hasPermissionFlag
      ? await context.hasPermission('aiHubFeature:view')
      : true;

    if (!(hasAccess && hasViewPermission)) {
      throw new Response('Forbidden', { status: 403 });
    }
  },
  loader: async ({ context }) => {
    await context.getInstance('http', 'defaultApi');
    await context.getInstance('i18n', '@mint-lib/formatting-hooks');
    await context.prefetchQuery(Chat.listRagDocuments({}));
  },
  head: () => ({
    meta: [
      {
        title: 'AI Hub | MINT',
      },
    ],
  }),
});
